import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class EmployeeMaster {
  constructor(
    public employeeNumber: number,
    public plant: string,
    public department: number,
    public firstName: string,
    public lastName: string
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class EmployeeMasterAdapter implements Adapter<EmployeeMaster> {
  adapt(item: any): EmployeeMaster {
    return new EmployeeMaster(
      item.PMEMP,
      item.PMPLT,
      item.PMDEPT,
      item.PMFNAM,
      item.PMLNAM
    );
  }
}
